import { MetaPartnerApiClient } from '@fourthwall/services/dist/MetaPartnerApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useMetaCatalogsQuery = createQueryHook(MetaPartnerApiClient.getMetaCatalogs, {
  queryKey: ['metaCatalogs'],
})
